package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import pl.decks.personal.components.widgets.dnahelix.DnaHelix
import pl.decks.personal.styles.SiteLayout

@Composable
fun NotesHelix(
    segments: Int,
    pointsPerSegment: Int,
    notes: Map<Int, String>,
    helixFrac: Float = 0.98f,
    helixHeight: Double = 200.0,
    mainStrainColor: Color? = null,
    secondaryStrainColor: Color? = null,
    modifier: Modifier = Modifier,
) = Column(
    modifier = Modifier.fillMaxWidth().gap(SiteLayout.Space.Small).then(modifier),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    var activeNote by remember(notes) { mutableStateOf(notes.keys.min()) }
    var visitedNodes by remember(notes) { mutableStateOf(setOf(activeNote)) }
    DnaHelix(
        segments = segments,
        pointsPerSegment = pointsPerSegment,
        modifier = Modifier.fillMaxWidth(helixFrac.times(100).percent).height(helixHeight.px),
        mainStrainColor = mainStrainColor,
        secondaryStrainColor = secondaryStrainColor,
    ) { ind ->
        if (ind in notes) HelixNode(
            when (ind) {
                activeNote -> ForewordStylesheet.Points.CurrentVariant
                in visitedNodes -> ForewordStylesheet.Points.VisitedVariant
                else -> null
            }
        ) {
            activeNote = ind
            visitedNodes = visitedNodes + ind
        }
    }
    NoteText(notes[activeNote] ?: "")
}

@Composable
private fun HelixNode(
    variant: CssStyleVariant<ForewordStylesheet.Points.Kind>? = null,
    onClick: () -> Unit
) = Box(
    ForewordStylesheet.Points.Base.toModifier(variant)
        .cursor(Cursor.Pointer)
        .onClick { onClick() }
)

@Composable
private fun NoteText(text: String) = Box(
    modifier = ForewordStylesheet.Note.Container.toModifier().height(5.cssRem),
    contentAlignment = Alignment.TopCenter,
) {
    SpanText(text, modifier = ForewordStylesheet.Note.Text.toModifier())
}
